// extracted by mini-css-extract-plugin
export default {"controls":"CollectionYardsPageHeaderComponent_controls__WEIor"};